function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_38315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9211 24.7171C36.3164 35.1637 25.7346 41.5212 15.2857 38.9162C4.8411 36.3118 -1.51716 25.7305 1.08864 15.2848C3.69215 4.83717 14.274 -1.52086 24.7197 1.08351C35.1679 3.68787 41.5258 14.2703 38.9208 24.7173L38.921 24.7171H38.9211Z",
    fill: "#F7931A",
    style: {
      fill: "#F7931A",
      fill: "color(display-p3 0.9686 0.5765 0.1020)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4549 17.5502C28.8502 14.9233 26.8382 13.5112 24.0869 12.5693L24.9795 9.01087L22.8003 8.47113L21.9315 11.9358C21.3586 11.7938 20.7703 11.66 20.1855 11.5273L21.0607 8.03974L18.8829 7.5L17.9899 11.0572C17.5158 10.9499 17.0502 10.8439 16.5984 10.7322L16.6009 10.721L13.5958 9.97505L13.0162 12.2886C13.0162 12.2886 14.6329 12.657 14.5988 12.6796C15.4813 12.8986 15.6409 13.4792 15.6144 13.9394L14.5977 17.9933C14.6584 18.0086 14.7373 18.0308 14.8242 18.0656C14.7515 18.0476 14.6742 18.028 14.5939 18.0089L13.1689 23.6878C13.061 23.9543 12.7873 24.3542 12.1703 24.2023C12.1922 24.2338 10.5865 23.8094 10.5865 23.8094L9.50458 26.2889L12.3404 26.9916C12.8679 27.1231 13.3849 27.2607 13.894 27.3901L12.9923 30.9893L15.1689 31.5291L16.0619 27.9681C16.6566 28.1285 17.2336 28.2765 17.7986 28.4161L16.9085 31.9603L19.0878 32.5L19.9894 28.9076C23.7054 29.6066 26.4994 29.3248 27.6755 25.9838C28.6232 23.294 27.6283 21.7425 25.6734 20.7308C27.0973 20.4044 28.1698 19.4735 28.4557 17.5505L28.455 17.55L28.4549 17.5502ZM23.4761 24.4901C22.8026 27.1799 18.2465 25.7258 16.7694 25.3612L17.966 20.5929C19.4431 20.9595 24.1799 21.6848 23.4762 24.4901H23.4761ZM24.15 17.5112C23.5357 19.9579 19.7436 18.7149 18.5134 18.4101L19.5984 14.0855C20.8285 14.3903 24.79 14.9592 24.1502 17.5112H24.15Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_38315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.504578 0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.c9e2a018cdc1e0794ef34fce6e57678b.svg";
export { ForwardRef as ReactComponent };